import { IStorageStrategy } from './storage-strategy.interface';
import { IBrowserAccessor } from '../browser';
import { expect } from '../expect';

export class DefaultStorageStrategy<T> implements IStorageStrategy<T> {
  private readonly browser: IBrowserAccessor;
  private readonly STORAGE_KEY: string;

  constructor(browser: IBrowserAccessor, storageKey: string) {
    this.browser = expect(browser).toBeDefined('The IBrowserAccessor implementation is required to construct DefaultStorageStrategy.');
    this.STORAGE_KEY = storageKey;
  }

  public async execute(params: T): Promise<T> {
    // only store if not already stored (avoid overwriting existing session values)
    const existingParams = await this.browser.sessionStorage.getItem(this.STORAGE_KEY);
    if (existingParams === null) {
      await this.browser.sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(params));
      return params;
    } else {
      // if sessionStorage already has value, do nothing (preserve original values)
      try {
        return JSON.parse(existingParams) as T;
      } catch {
        // if parse fails, remove corrupted data
        await this.browser.sessionStorage.removeItem(this.STORAGE_KEY);
        return null;
      }
    }
  }
}
